import React, { Component } from "react";

import axios from "@app/lib/axios";
import { format } from "date-fns";

import * as util from "@app/lib/utility";
import ExcelDownloadBtn from "@app/components/Stat/ExcelDownloadBtn";
import { SelectStatPeriod, getDefinedPeriod } from "@app/components/Stat/SelectStatPeriod/index";

import ViewSubOption from "./components/ViewSubOption";

import MomoConfig from "./config";
import Branch from "./Branch/Branch";
import Nursery from "./Branch/Nursery";
import Class from "./Branch/Class";

class StatMomoBranch extends Component {
    constructor(props) {
        super(props);
        const isRoleBranch = util.isRoleBranch();
        var branchId = 0;
        var branchName = "";
        var statStartDate = new Date(MomoConfig.service.startDate); // 서비스 시작일
        var statMinDate = new Date(MomoConfig.service.startDate); // 서비스 시작일
        const now = new Date();
        // 지사는 설정된 월(현재 3월)까지는 전년도 통계 조회 가능하며 이후에는 해당 학년도 통계만 조회 가능
        this.showLastYearShortCut = now.getMonth() < MomoConfig.service.showPrevYearMonth;
        statMinDate = new Date(now.getMonth() < MomoConfig.service.showPrevYearMonth ? `${now.getFullYear() - 1}-03-01` : `${now.getFullYear()}-03-01`);
        if(statMinDate < statStartDate) {
            statMinDate = statStartDate;
        }
        if (isRoleBranch) {
            const logInfo = util.getLoginBranchInfo();
            branchId = logInfo.id;
            branchName = logInfo.name;
        }
        const periodInit = getDefinedPeriod("week", "current");

        this.state = {
            isRoleBranch: isRoleBranch,
            branchId: branchId,
            branchName: branchName,
            branchList: [],
            selectBranch: branchId > 0,
            nurseryUniqId: 0,
            nurseryName: null,
            statPeriod: {
                startDate: format(periodInit.startDate, "yyyy-MM-dd"),
                endDate: format(periodInit.endDate, "yyyy-MM-dd"),
                type: "week",
            },
            statMinDate: statMinDate,
            viewCategory: "branch",
            viewCategorySub: null,
            categorySubOption: [
                { name: "한글", id: "k" },
                { name: "수학", id: "m" },
            ],
            showCategorySubOption: false,
            defaultCategorySubOption: "k",
            selectedCategorySubOption: "k",
            selectedCategorySubOptionMeta: null,
            categorySubOption2: null,
            defaultCategorySubOption2: "-",
            selectedCategorySubOption2: "-",
            selectedCategorySubOption2Meta: null,
            mainStat: false,
            categoryStat: false,
        };
        this.childView = React.createRef();
    }

    componentDidMount() {
        if (!this.state.isRoleBranch) {
            this.getBranchList();
        }
    }

    getBranchList = () => {
        this.setState(
            {
                selectBranch: false,
            },
            function () {
                axios({
                    method: "get",
                    url: `/api/stat_momo/hq/contract/branches`,
                })
                    .then((result) => {
                        if (result.data.code === 200) {
                            var sortedList = result.data.branches.sort((a, b) => {
                                if (a.name < b.name) {
                                    return -1;
                                } else if (a.name > b.name) {
                                    return 1;
                                } else {
                                    return 0;
                                }
                            });
                            this.setState({
                                branchList: sortedList,
                                selectBranch: true,
                                branchId: sortedList[0].id,
                                branchName: sortedList[0].name,
                            });
                        } else {
                            alert("지사 목록을 가져오는데 실패하였습니다.\n지속 발생시 관리자에게 문의해주세요.");
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        );
    };
    changeBranch = (value) => {
        var branchId = value;
        var branchName = "";

        var branchList = this.state.branchList;
        for (var i = 0; i < branchList.length; i++) {
            var branch = branchList[i];
            if (Number(branch.id) === Number(branchId)) {
                branchName = branch.name;
                break;
            }
        }

        this.setState({
            branchId: branchId,
            branchName: branchName,
            viewCategory: "branch",
            viewCategorySub: null,
            nurseryUniqId: null,
            nurseryName: null,
            categorySubOption2: null,
            defaultCategorySubOption2: "-",
            selectedCategorySubOption2: "-",
            selectedCategorySubOption2Meta: null,
        });
    };

    onPeriodChangeHandler = (startDate, endDate, periodType) => {
        this.setState(
            {
                statPeriod: {
                    startDate: format(startDate, "yyyy-MM-dd"),
                    endDate: format(endDate, "yyyy-MM-dd"),
                    type: periodType,
                },
            },
            () => {}
        );
    };

    onBranchSelected = (branchId) => {
        this.changeBranch(branchId);
    };

    onSelectNursery = (nurseryUniqId, nurseryName) => {
        this.setState({ nurseryUniqId, nurseryName, viewCategory: "nursery" }, () => {});
    };

    onCategorySubOptionSelected = (selected, metaData) => {
        this.setState({ selectedCategorySubOption: selected, selectedCategorySubOptionMeta: metaData }, () => {});
    };

    updateCategorySubOption2 = (data, defaultSelected = "-") => {
        this.setState({
            categorySubOption2: data,
            defaultCategorySubOption2: defaultSelected,
            selectedCategorySubOption2: defaultSelected,
        });
    };

    onCategorySubOption2Selected = (selected, metaData) => {
        this.setState({ selectedCategorySubOption2: selected, selectedCategorySubOption2Meta: metaData }, () => {});
    };

    updateMainStat = (data) => {
        this.setState({ mainStat: data });
    };

    updateCategoryStat = (data) => {
        this.setState({ categoryStat: data });
    };

    onViewBack = () => {
        if (this.state.viewCategory == 'nursery') {
            if(this.state.selectedCategorySubOption2 == '-') {
                this.setState({ viewCategory: "branch", viewCategorySub: null, nurseryUniqId: null, nurseryName: null, categoryStat: null });
            } else {
                this.setState({ selectedCategorySubOption2: '-' });
            }
        }
    };

    changePage = (e) => {
        const urlBase = process.env.REACT_APP_BASE_URL;
        document.location.href = urlBase + "/stat/momo/" + e;
    }

    render() {
        const {
            isRoleBranch,
            statPeriod,
            statMinDate,
            branchList,
            branchId,
            branchName,
            nurseryUniqId,
            nurseryName,
            className,
            viewCategory,
            viewCategorySub,
            categorySubOption,
            defaultCategorySubOption,
            selectedCategorySubOption,
            categorySubOption2,
            defaultCategorySubOption2,
            selectedCategorySubOption2,
            mainStat,
            categoryStat,
        } = this.state;
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <h2 className="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-4pageheader-title">
                                모모 한글수
                            </h2>
                            {!isRoleBranch && (<div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2 float-right">
                                <select className="form-control form-control-lg" name="month" value={"branch"} onChange={(e) => this.changePage(e.target.value)} style={{ fontSize: "1.3em" }}>
                                    <option value="hq">본사</option>
                                    <option value="branch">지사</option>
                                </select>
                            </div>)}
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content">
                        <div className="row mb-3">
                            {viewCategory != "branch" && (
                                <div className="col-xl-1 col-lg-3 col-md-3 col-sm-3 col-4" style={{ minWidth: "59px", maxWidth: "59px", marginTop: "-5px" }}>
                                    <button
                                        className="btn btn-default"
                                        style={{
                                            border: "0px",
                                            width: "44px",
                                        }}
                                        type="button"
                                        onClick={this.onViewBack}
                                    >
                                        <span className="fa fa-lg fa-chevron-left" aria-hidden="true" />
                                    </button>
                                </div>
                            )}
                            <div className="col-xl-3 col-lg-9 col-md-9 col-sm-9 col-8">
                                <SelectStatPeriod
                                    id="select-stat-period"
                                    minDate={statMinDate}
                                    showLastYearShortCut={this.showLastYearShortCut}
                                    onPeriodChangeHandler={this.onPeriodChangeHandler.bind(this)}
                                />
                            </div>
                            {!isRoleBranch && viewCategory == "branch" && (
                                <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <ViewSubOption data={branchList} onOptionSelect={this.onBranchSelected.bind(this)} selected={branchId} />
                                </div>
                            )}
                            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                <ViewSubOption
                                    data={categorySubOption}
                                    defaultSelected={defaultCategorySubOption}
                                    onOptionSelect={this.onCategorySubOptionSelected.bind(this)}
                                    selected={selectedCategorySubOption}
                                />
                            </div>
                            {nurseryName && <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12 h5 mt-1">{nurseryName}</div>}
                            {!viewCategorySub && (
                                <div className="col-xl-2 col-lg-6 col-md-6 col-sm-12 col-12">
                                    <ViewSubOption
                                        data={categorySubOption2}
                                        defaultSelected={defaultCategorySubOption2}
                                        onOptionSelect={this.onCategorySubOption2Selected.bind(this)}
                                        selected={selectedCategorySubOption2}
                                    />
                                </div>
                            )}
                            <ExcelDownloadBtn view={this.childView} statPeriod={statPeriod} />
                        </div>
                        <div className="row">
                            <div className="col-12">
                                {viewCategory == "branch" && (
                                    <Branch
                                        isRoleBranch={isRoleBranch}
                                        statPeriod={statPeriod}
                                        branchId={branchId}
                                        branchName={branchName}
                                        stat={mainStat}
                                        updateMainStat={this.updateMainStat.bind(this)}
                                        selectedCategorySubOption={selectedCategorySubOption}
                                        onSelectNursery={this.onSelectNursery.bind(this)}
                                        ref={this.childView}
                                    />
                                )}
                                {viewCategory == "nursery" && selectedCategorySubOption2 == '-' && (
                                    <Nursery
                                        statPeriod={statPeriod}
                                        branchId={branchId}
                                        branchName={branchName}
                                        nurseryUniqId={nurseryUniqId}
                                        nurseryName={nurseryName}
                                        stat={categoryStat}
                                        updateCategoryStat={this.updateCategoryStat.bind(this)}
                                        selectedCategorySubOption={selectedCategorySubOption}
                                        updateClassList={this.updateCategorySubOption2.bind(this)}
                                        onSelectClass={this.onCategorySubOption2Selected.bind(this)}
                                        ref={this.childView}
                                    />
                                )}
                                {viewCategory == "nursery" && selectedCategorySubOption2 != '-' && (
                                    <Class
                                        statPeriod={statPeriod}
                                        branchId={branchId}
                                        branchName={branchName}
                                        nurseryUniqId={nurseryUniqId}
                                        nurseryName={nurseryName}
                                        classList={categoryStat ? categoryStat.classes : null}
                                        selectedCategorySubOption={selectedCategorySubOption}
                                        classId={selectedCategorySubOption2}
                                        ref={this.childView}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="text-xs text-primary float-right">
                                    ※ 정확한 통계 제공을 위해 현재 날짜의 전일까지의 통계만 제공됩니다.
                                    <br />※ 당해 학년도의 3월~2월까지의 통계 데이터만 제공됩니다.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default StatMomoBranch;
